<template>
  <span>
    <i class="fas fa-question-circle" :class="iconClasses" :id="tooltipId"></i>
    <b-tooltip :target="tooltipId" :class="tooltipClasses" :variant="variant" :placement="placement">
      <slot></slot>
    </b-tooltip>
  </span>
</template>


<script>
export default {
  name: "customTooltip",
  props: {
    placement: {
      type: String,
      default: 'right'
    },
    variant: {
      type: String,
      default: 'secondary'
    },
    iconClasses: {
      type: [String, Object],
      default: "default-custom-tooltip__icon"
    },
    tooltipClasses: {
      type: [String, Object],
      default: "default-custom-tooltip"
    },
    name: {
      type: String,
      default: ''
    }
  },
  computed: {
    tooltipId () {
      return `tooltip-${this.name}`
    }
  }
}
</script>
